import axios from "axios";
import { EncryptStorage } from "encrypt-storage";

// import { toast } from "react-toastify";
// toast.configure();

const encryptStorage1 = new EncryptStorage("secret-key", {
  prefix: "@instance1",
});

// axios.interceptors.request.use(
//   (config) => {
//     const data = encryptStorage1.getItem("azalea_user");

//     if (config.headers["reqJWT"] === true) {
//       if (config.headers["jwt"]) {
//         config.headers["Authorization"] = "Bearer " + config.headers["jwt"];
//       } else if (data) {
//         config.headers["Authorization"] = "Bearer " + data.jwt;
//       }
//     }
//     delete config.headers["jwt"];
// console.log("config",config)

//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

//functions to make api calls
const api = {
  fetchRequest: (method, headers, body, finalUrl, responseType) => {
    const requestMethod = String(method || "").toUpperCase();
    const config = {
      method: method,
      headers: headers,
      baseURL: finalUrl,
    };
    if (responseType) config.responseType = responseType;

    if (requestMethod !== "GET" && body !== undefined) {
      config.data = body;
    } else if (requestMethod === "GET" && headers["Content-Type"]) {
      // Axios' XHR adapter removes Content-Type when data is undefined.
      // An empty string preserves the header and XHR still sends no body.
      config.data = "";
      config.transformRequest = [(data) => data];
    }

    return axios(config);
  },
};
export default api;
